"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _riskControl = require("@/api/riskControl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RiskControlDialog',
  data: function data() {
    var _this = this;
    return {
      visible: false,
      loading: false,
      dialogType: 'add',
      // add / edit
      dialogTitle: '新增风控名单',
      editId: null,
      form: {
        addWay: 'single',
        accountType: 'phone',
        account: '',
        reason: ''
      },
      uploadFile: null,
      rules: {
        accountType: [{
          required: true,
          message: '请选择风控账号类型',
          trigger: 'change'
        }],
        account: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }],
        reason: [{
          required: true,
          message: '请输入风控原因',
          trigger: 'blur'
        }],
        file: [{
          required: true,
          message: '请导入Excel文件',
          trigger: 'change',
          validator: function validator(rule, value, callback) {
            if (_this.dialogType === 'add' && _this.form.addWay === 'batch' && !_this.uploadFile) {
              callback(new Error('请导入Excel文件'));
            } else {
              callback();
            }
          }
        }]
      }
    };
  },
  methods: {
    open: function open(_ref) {
      var _this2 = this;
      var _ref$type = _ref.type,
        type = _ref$type === void 0 ? 'add' : _ref$type,
        _ref$title = _ref.title,
        title = _ref$title === void 0 ? '新增风控名单' : _ref$title,
        _ref$row = _ref.row,
        row = _ref$row === void 0 ? null : _ref$row;
      this.dialogType = type;
      this.dialogTitle = title;
      this.visible = true;
      this.$nextTick(function () {
        _this2.$refs.form.resetFields();
        if (type === 'edit' && row) {
          _this2.editId = row.id;
          _this2.form.accountType = row.accountType;
          _this2.form.account = row.account;
          _this2.form.reason = row.reason;
        } else {
          _this2.form.addWay = 'single';
          _this2.form.accountType = 'phone';
          _this2.form.account = '';
          _this2.form.reason = '';
          _this2.uploadFile = null;
          _this2.$refs.upload && _this2.$refs.upload.clearFiles();
        }
      });
    },
    onClose: function onClose() {
      this.$refs.form.resetFields();
    },
    handleFileChange: function handleFileChange(file) {
      console.log('file---', file);
      this.uploadFile = file.raw;
      this.$refs.form.validateField('file');
    },
    clearFile: function clearFile() {
      this.uploadFile = null;
      this.$refs.upload && this.$refs.upload.clearFiles();
      this.$refs.form.validateField('file');
    },
    downloadTemplate: function downloadTemplate() {
      var link = document.createElement('a');
      link.href = process.env.VUE_APP_VISIT_URL + '/assets/riskControl/fengkong.xlsx';
      link.download = '风控名单模板.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onSubmit: function onSubmit() {
      var _this3 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        _this3.$confirm('确认风控当前用户？', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          if (_this3.dialogType === 'add' && _this3.form.addWay === 'single') {
            var params = {
              accountType: _this3.form.accountType === 'phone' ? 1 : 2,
              account: _this3.form.account,
              riskReason: _this3.form.reason
            };
            _this3.loading = true;
            (0, _riskControl.saveRiskBlacklist)(params).then(function () {
              _this3.$notify.success({
                title: '温馨提示',
                message: '新增成功'
              });
              _this3.visible = false;
              _this3.$emit('refresh');
            }).finally(function () {
              _this3.loading = false;
            });
          } else if (_this3.dialogType === 'add' && _this3.form.addWay === 'batch') {
            var formData = new FormData();
            formData.append('file', _this3.uploadFile);
            _this3.loading = true;
            (0, _riskControl.importRiskBlacklist)(formData).then(function () {
              _this3.$notify.success({
                title: '温馨提示',
                message: '导入成功'
              });
              _this3.visible = false;
              _this3.$emit('refresh');
            }).finally(function () {
              _this3.loading = false;
            });
          } else {
            var _params = {
              id: _this3.editId,
              riskReason: _this3.form.reason
            };
            _this3.loading = true;
            (0, _riskControl.editRiskBlacklist)(_params).then(function () {
              _this3.$notify.success({
                title: '温馨提示',
                message: '编辑成功'
              });
              _this3.visible = false;
              _this3.$emit('refresh');
            }).finally(function () {
              _this3.loading = false;
            });
          }
        }).catch(function () {});
      });
    },
    onReset: function onReset() {
      if (this.dialogType === 'edit') {
        // 编辑时只重置原因
        this.form.reason = '';
      } else {
        this.$refs.form.resetFields();
        this.form.addWay = 'single';
        this.uploadFile = null;
      }
    }
  }
};